// Top chrome (brand + nav) for logged-in pages.
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

interface ChromeProps {
  tag?: string;
}

export function Chrome({ tag = "Editor" }: ChromeProps) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate("/login");
  }

  return (
    <header className="flex items-center justify-between border-b border-rule-soft bg-paper px-7 py-5">
      <div className="flex items-baseline gap-3">
        <Link
          to="/edit"
          className="font-display text-2xl tracking-[-0.04em] text-ink [font-variation-settings:'opsz'_96,'SOFT'_80,'WONK'_1,'wght'_500]"
        >
          Varo
        </Link>
        <span className="ml-1 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-mute">
          {tag}
        </span>
      </div>
      <nav className="flex items-center gap-7">
        {user && (
          <Link
            to={`/${user.username}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-ink-soft hover:text-terra"
          >
            View public ↗
          </Link>
        )}
        <button onClick={handleSignOut} className="text-sm text-ink-soft hover:text-terra">
          Sign out
        </button>
      </nav>
    </header>
  );
}
